export default function storage(key, value, mode = 'get') {
  if (mode === 'set') {
    localStorage.setItem(key, value);
  }
  return localStorage.getItem(key);
}
